import { useEffect, useState } from "react";

export const THANAWYA_SECTIONS = [
  { value: "scientific", label: "Scientific" },
  { value: "arts", label: "Arts" },
];

export const BACCALAUREATE_SECTIONS = [
  { value: "bac_medicine_science", label: "الطب والعلوم" },
  { value: "bac_engineering_cs", label: "الهندسة وعلوم الحاسب" },
  { value: "bac_business", label: "الاعمال" },
  { value: "bac_arts_literature", label: "الاداب والفنون" },
];

export const NATIONAL_SECTION_LABELS = {
  scientific: "Scientific",
  arts: "Arts",
  both: "Both",
  bac_medicine_science: "الطب والعلوم",
  bac_engineering_cs: "الهندسة وعلوم الحاسب",
  bac_business: "الاعمال",
  bac_arts_literature: "الاداب والفنون",
};

export function getSectionLabel(section) {
  if (!section) return "";
  return NATIONAL_SECTION_LABELS[section] || section;
}

export function isBaccalaureateSection(section) {
  return String(section || "").startsWith("bac_");
}

/**
 * Second Secondary (stage 2): Thanaweya Amma (Scientific/Arts)
 * or Baccalaureate (4 tracks).
 */
export default function NationalSecondSecondarySections({
  register,
  errors,
  setValue,
  currentSection,
  includeBoth = false,
  required = true,
  disabled = false,
  serverError,
}) {
  const inferredSystem = isBaccalaureateSection(currentSection)
    ? "baccalaureate"
    : currentSection === "scientific" ||
        currentSection === "arts" ||
        currentSection === "both"
      ? "thanaweya"
      : "";

  const [system, setSystem] = useState(inferredSystem);

  useEffect(() => {
    if (inferredSystem) {
      setSystem(inferredSystem);
    }
  }, [inferredSystem]);

  const handleSystemChange = (nextSystem) => {
    setSystem(nextSystem);
    setValue("section", null, { shouldValidate: true });
  };

  const trackOptions =
    system === "baccalaureate"
      ? BACCALAUREATE_SECTIONS
      : system === "thanaweya"
        ? THANAWYA_SECTIONS
        : [];

  return (
    <div className="flex w-full flex-col items-start gap-6">
      <div className="flex w-full flex-wrap items-center gap-10 sm:flex-col sm:items-start sm:gap-4">
        <div className="flex items-center gap-2">
          <input
            className="cursor-pointer"
            type="radio"
            id="thanaweya_amma"
            name="national_system"
            checked={system === "thanaweya"}
            disabled={disabled}
            onChange={() => handleSystemChange("thanaweya")}
          />
          <label className="cursor-pointer text-start" htmlFor="thanaweya_amma">
            ثانوية عامة
          </label>
        </div>
        <div className="flex items-center gap-2">
          <input
            className="cursor-pointer"
            type="radio"
            id="baccalaureate"
            name="national_system"
            checked={system === "baccalaureate"}
            disabled={disabled}
            onChange={() => handleSystemChange("baccalaureate")}
          />
          <label className="cursor-pointer text-start" htmlFor="baccalaureate">
            بكالوريا
          </label>
        </div>
      </div>

      {trackOptions.length > 0 && (
        <div className="flex w-full flex-wrap items-end gap-10 pb-1 sm:flex-col-reverse sm:items-start sm:gap-6">
          {trackOptions.map((option) => (
            <div
              key={option.value}
              className="flex items-center justify-center gap-2"
            >
              <input
                className="cursor-pointer"
                type="radio"
                id={option.value}
                value={option.value}
                disabled={disabled}
                {...register("section", { required })}
              />
              <label
                className="cursor-pointer text-start whitespace-nowrap"
                htmlFor={option.value}
              >
                {option.label}
              </label>
            </div>
          ))}
          {includeBoth && (
            <div className="flex items-center justify-center gap-2">
              <input
                className="cursor-pointer"
                type="radio"
                id="national_both"
                value="both"
                disabled={disabled}
                {...register("section", { required })}
              />
              <label
                className="cursor-pointer text-start"
                htmlFor="national_both"
              >
                Both
              </label>
            </div>
          )}
        </div>
      )}

      {errors?.section && (
        <p className="w-full text-start text-[12px] text-blue-900">
          {errors.section.type === "required" && "Please fill out this field"}
        </p>
      )}
      {serverError && (
        <p className="w-full text-start text-[12px] text-blue-900">
          {serverError}
        </p>
      )}
    </div>
  );
}
